import { useTranslation } from 'react-i18next'
import { HelpCenterTranslations } from '@/HelpCenter/ui/helpCenterTranslations'
import { useHelpCenter } from '@/HelpCenter/ui/context/HelpCenterContext'
import {
    OreRadioButton,
    OreStack,
    OreText
} from '@edenredespana/oreneta'

export const NewTicketStep1 = (): JSX.Element => {
    const { t } = useTranslation()
    const { caseReasons, form } = useHelpCenter()
    const selectedReasonId = form.watch('caseReasonId')

    return (
        <OreStack space="medium" placeContent="stretch">
            <OreStack space="xsmall" placeContent="stretch">
                <OreText size="text-lg" bold>{t(HelpCenterTranslations.step1.title)}</OreText>
                <OreText>{t(HelpCenterTranslations.step1.subtitle)}</OreText>
            </OreStack>
            <OreStack space="small" placeContent="stretch">
                {caseReasons?.map((reason) => (
                    <OreRadioButton
                        key={reason.caseReasonId}
                        label={reason.descriptionWeb}
                        name="caseReasonId"
                        value={String(reason.caseReasonId)}
                        checked={selectedReasonId === reason.caseReasonId}
                        onChange={() => form.setValue('caseReasonId', reason.caseReasonId, { shouldValidate: true })}
                    />
                ))}
            </OreStack>
        </OreStack>
    )
}


